export { Link as default } from './Link';
